<template>
  <div class="row-cols-lg-2">
    <b-row no-gutters>
    <b-col class="d-block p-2 bg-mdh text-white">
      Facility
    </b-col>
    <b-col>
      {{ selectedFacility }}
    </b-col>
  </b-row>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  data: () => ({

  }),
  props: {
    selectedFacility: String
  },

  created() {
  },
  computed: {
    id() {
      if (this.setId === null) {
        return _.uniqueId('selector')
      } else {
        return this.setId
      }
    },
  },
  methods: {

  },
}

</script>

<style scoped>

</style>
